import React, { useCallback, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import styles from '../../assets/stylesheets/pages/searches/back-to-top.module.scss'

import { scrollToTop } from './search_page'

const BackToTop = ({ mockScrollValue, mountPoint }) => {
  const [atTop, setAtTop] = useState(mockScrollValue ? mockScrollValue === 0 : window.scrollY === 0)

  const watchScroll = useCallback(() => {
    setAtTop(window.scrollY === 0)
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', watchScroll)

    return () => {
      window.removeEventListener('scroll', watchScroll)
    }
  }, [watchScroll])

  return ReactDOM.createPortal(
    <a
      href='#back-to-top'
      aria-label='Back to Top'
      className={styles['back-to-top-button']}
      data-show={!atTop}
      onClick={scrollToTop}
    >
      <img src='/chevron-up.svg' alt='' />
    </a>,
    mountPoint
  )
}

BackToTop.propTypes = {
  mockScrollValue: PropTypes.number,
  mountPoint: PropTypes.instanceOf(Element)
}

export default BackToTop
